import { combineReducers } from 'redux'

import specific from './specific/reducers'

const myReducer = combineReducers({
  specific,
})

export default myReducer
